import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"bv-card__footer\" ...attributes>\n  {{yield}}\n</div>")